enum ClickReportSorting {
  Team = 'Team',
  TeamMember = 'TeamMember',
  Date = 'Date',
  Client = 'Client',
}

export default ClickReportSorting;
